import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class UserTypes {
  static listAffiliates: IActionType = new ActionType('USER/LIST_AFFILIATE');
  static listCoupons: IActionType = new ActionType('USER/LIST_COUPON');
  static user: IActionType = new ActionType('USER/GET_USER');
  static originalUser: IActionType = new ActionType('USER/ORIGINAL_USER');
}

export default UserTypes;
